import React, { useCallback, useRef, useState } from 'react';
import { IconButton } from '@pypestream/design-system';

import { useCsvUploadModal } from '../modals';

export const CsvUploader = React.memo(() => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [file, setFile] = useState<File | null>(null);
  const { openModal, modal } = useCsvUploadModal({
    file,
    onClose: () => {
      resetFile();
      resetInput();
    },
  });

  const handleButtonClick = () => {
    inputRef.current?.click();
  };

  const handleFileChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const uploadedFile = e.target.files?.[0];
      if (!uploadedFile) return;

      if (!uploadedFile.name.toLowerCase().endsWith('.csv')) {
        console.error('Please upload a valid CSV file.');
        return;
      }

      setFile(uploadedFile);
      openModal();
    },
    [openModal]
  );

  const resetInput = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  }, []);

  const resetFile = useCallback(() => {
    setFile(null);
  }, []);

  return (
    <div style={{ display: 'flex' }}>
      <input
        multiple={false}
        data-test-id="ps-csv-uploader-input"
        type="file"
        accept=".csv"
        ref={inputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />

      <IconButton
        test-id="ps-csv-uploader-btn"
        size="small"
        name="upload"
        onClick={handleButtonClick}
      />
      {modal}
    </div>
  );
});
